import { render, staticRenderFns } from "./showConvocationFormAccepted.vue?vue&type=template&id=116ff132"
import script from "./showConvocationFormAccepted.vue?vue&type=script&lang=js"
export * from "./showConvocationFormAccepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports